import React, {useState} from "react";
import GroupBySelect from "./GroupBySelect";
import {useForm} from "react-hook-form";
import {FileCopyOutlined, FileDownloadOutlined, Tune, ViewColumnOutlined} from "@mui/icons-material";
import {connect} from "react-redux";
import {groupBy1Action} from "../../store/actions/groupBy1Action";
import {groupBy2Action} from "../../store/actions/groupBy2Action";
import {groupBy3Action} from "../../store/actions/groupBy3Action";
import {Box, Button, Collapse, useMediaQuery, useTheme} from "@mui/material";
import {ReportActionMenu, ReportingDateControls, reportingIconStyles, reportingInputStyles, reportingToolbarStyles} from "../utils/ReportingToolbarDesign";
import {ddToolbarActions} from "../../store/actions/ddToolbarActions";
import {GetLocalStorageCache, SetLocalStorageCache} from "../cache/Cache";
import ColumnSettings from "./ColumnSettings";

export function DetailPanelToolbar(props) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [groupingOpen, setGroupingOpen] = useState(false);
    const {campaignId, onClickRefresh, columns, report, columnGroup, isTreeView} = props;
    const {control, watch, setValue} = useForm();
    const {from, to, dateLabel} = props.ddToolbarState;

    const [openColumnSettings, setOpenColumnSettings] = useState(false);

    const handleGroupBySelectedOptionCache = (groupByNumber, groupBy) => {

        if (props?.campaignsState?.selectedRows.size > 1 && props?.campaignsState?.filterTrafficSources?.length === 0) {
            return false;
        }
        if (props?.campaignsState?.selectedRows.size !== 1 && props?.campaignsState?.filterTrafficSources?.length === 0) {
            return false;
        }

        let trafficSourceName = "";
        props?.campaignsState?.data?.records?.forEach(item => {
            if (item.id === campaignId) {
                trafficSourceName = item?.trafficSourceName;
            }
            if (props?.campaignsState?.filterTrafficSources?.length === 1) {
                trafficSourceName = item?.trafficSourceName;
            }
        });

        let cache = GetLocalStorageCache("groupBySelect");
        if (cache !== null && cache !== undefined && cache !== "") {
            for (const item of cache) {
                if (item?.name === trafficSourceName) {
                    if (groupByNumber === 1) {
                        props.updateGroupBy1(groupBy)
                        item.g1 = groupBy;
                    } else if (groupByNumber === 2) {
                        props.updateGroupBy2(groupBy)
                        item.g2 = groupBy;
                    } else if (groupByNumber === 3) {
                        props.updateGroupBy3(groupBy)
                        item.g3 = groupBy;
                    }
                }
            }
            SetLocalStorageCache("groupBySelect", cache);
        }
    };

    const getTrafficSourceId = () => {
        let id = 0;
        if (props?.campaignsState?.filterTrafficSources?.length !== 1) {
            return id;
        }

        for (const item of props?.campaignsState?.filterTrafficSources) {
            id = item?.value;
        }
        return id;
    };

    const handleOnCloseColumnSettings = () => {
        setOpenColumnSettings(false);
        onClickRefresh();
    };

    const handleOpenColumnSettings = () => {
        setOpenColumnSettings(true);
    };

    const actions = [
        props?.campaignsState?.detailsReportingView !== 'tree' && {label: 'Export to CSV', icon: <FileDownloadOutlined/>, group: 'report', onClick: props.onClickExportCSV},
        {label: 'Copy selected names', icon: <FileCopyOutlined/>, group: 'report', onClick: props.onClickCopyNames, disabled: props.selectedCount === 0},
        {label: 'Column settings', icon: <ViewColumnOutlined/>, group: 'report', onClick: handleOpenColumnSettings}
    ];
    const groupingControls = <Box id="report-grouping" sx={{...reportingInputStyles, display: 'flex', flexWrap: 'wrap', gap: 1, minWidth: 0, pt: mobile ? 2 : 0, flex: mobile ? undefined : '1 0 440px',
        '& .MuiTextField-root': {my: 0}, '& .MuiOutlinedInput-root': {...reportingInputStyles['& .MuiOutlinedInput-root'], minWidth: 0, mt: 0, border: 0},
        '& .MuiAutocomplete-input': {mt: '0 !important', fontSize: '13px !important'}}}>
        <Box sx={{minWidth: mobile ? 0 : 140, flex: mobile ? "1 1 200px" : "1 1 140px"}}>
            <GroupBySelect
                trafficSourceId={getTrafficSourceId()}
                setValue={setValue}
                watch={watch}
                control={control}
                updateGroupBy={(selectedOption) => {
                    props?.groupBy1State?.selectedRows?.clear();
                    props?.groupBy1State?.selectedUUIDs?.clear();
                    props?.groupBy2State?.selectedRows?.clear();
                    props?.groupBy2State?.selectedUUIDs?.clear();
                    props?.groupBy3State?.selectedRows?.clear();
                    props?.groupBy3State?.selectedUUIDs?.clear();

                    if (selectedOption?.groupBy === "ipv4") {
                        props?.updateGroupBy2({
                            "label": "Date",
                            "groupBy": "date",
                            "sortBy": "date"
                        });
                        props?.updateGroupBy3({
                            "label": "Hour Of Day",
                            "groupBy": "hour_of_day",
                            "sortBy": "hour_of_day"
                        });
                    }
                    handleGroupBySelectedOptionCache(1, selectedOption);
                    props?.updateGroupBy1(selectedOption)
                }}
                campaignId={campaignId}
                inputName="groupBy"
                inputLabel="Group by 1"
                defaultValue={props?.groupBy1State?.groupBy}
            />
        </Box>
        <Box sx={{minWidth: mobile ? 0 : 140, flex: mobile ? "1 1 200px" : "1 1 140px"}}>
            <GroupBySelect
                trafficSourceId={getTrafficSourceId()}
                setValue={setValue}
                watch={watch}
                control={control}
                updateGroupBy={(selectedOption) => {
                    props?.groupBy2State?.selectedRows?.clear();
                    handleGroupBySelectedOptionCache(2, selectedOption);
                    props?.updateGroupBy2(selectedOption);
                    if (isTreeView) {
                        props?.updateTreeViewData({groupByNumber: 2})
                    }
                }}
                campaignId={campaignId}
                inputName="groupBy2"
                inputLabel="Group by 2"
                defaultValue={props?.groupBy2State?.groupBy}
            />
        </Box>
        <Box sx={{minWidth: mobile ? 0 : 140, flex: mobile ? "1 1 200px" : "1 1 140px"}}>
            <GroupBySelect
                trafficSourceId={getTrafficSourceId()}
                setValue={setValue}
                watch={watch}
                control={control}
                updateGroupBy={(selectedOption) => {
                    props?.groupBy3State?.selectedRows?.clear();
                    handleGroupBySelectedOptionCache(3, selectedOption);
                    props?.updateGroupBy3(selectedOption);
                    if (isTreeView) {
                        props?.updateTreeViewData({groupByNumber: 3})
                    }
                }}
                campaignId={campaignId}
                inputName="groupBy3"
                inputLabel="Group by 3"
                defaultValue={props?.groupBy3State.groupBy}
            />
        </Box>
    </Box>;
    const actionMenu = <ReportActionMenu actions={actions} selectedCount={props.selectedCount}/>;
    const dateControls = <ReportingDateControls from={from} to={to} dateLabel={dateLabel} onChangeDate={props.updateDateRange}
        onRefresh={onClickRefresh} onColumns={handleOpenColumnSettings} iconOnly={mobile} showDayNavigationOnMobile/>;
    return <Box component="section" aria-label="Grouped report toolbar" sx={reportingToolbarStyles}>
        {mobile ? <>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, minWidth: 0,
                '& .MuiIconButton-root': {width: 32, height: 32},
                '& .report-date-controls': {gap: 0.5}}}>
                <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75}}>
                    <Button color="inherit" startIcon={<Tune/>} aria-label="Group by" aria-expanded={groupingOpen} aria-controls="report-grouping"
                        onClick={() => setGroupingOpen(value => !value)} sx={{...reportingIconStyles, width: 'auto', minWidth: 0, px: 1.25,
                            ...(groupingOpen && {color: 'primary.main'})}}>Group By</Button>
                    {actionMenu}
                </Box>
                <Box sx={{ml: 'auto', flexShrink: 0}}>{dateControls}</Box>
            </Box>
            <Collapse in={groupingOpen}>{groupingControls}</Collapse>
        </> : <Box sx={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, minWidth: 0}}>
            {groupingControls}
            {actionMenu}
            <Box sx={{ml: 'auto', minWidth: 0, maxWidth: '100%'}}>{dateControls}</Box>
        </Box>}
        {openColumnSettings && <ColumnSettings open columns={columns} report={report} columnGroup={columnGroup} onClose={handleOnCloseColumnSettings}/>}
    </Box>;

}

const mapStateToProps = (state) => {
    return {
        campaignsState: state.campaign,
        groupBy1State: state.groupBy1,
        groupBy2State: state.groupBy2,
        groupBy3State: state.groupBy3,
        ddToolbarState: state.ddToolbar
    }
};

const actionCreators = {
    updateGroupBy1: groupBy1Action.updateGroupBy,
    updateGroupBy2: groupBy2Action.updateGroupBy,
    updateGroupBy3: groupBy3Action.updateGroupBy,
    updateTreeViewData: groupBy1Action.updateTreeViewData,
    updateDateRange: ddToolbarActions.updateDateRange,
};

export default connect(mapStateToProps, actionCreators)(DetailPanelToolbar);
